import React from 'react';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import useGlobal from '../../../../store';
import LoadingButton from '../../../../facturotopia/LoadingButton';

const mapState = (store) => {
  return {
    busy: store.modulo.retenciones_masivas.files.list.busy,
  };
};

const mapActions = (actions, containers) => {
  return {
    downloadFile: actions.modulo.retenciones_masivas.files.list.downloadFile,
    downloadCfdis: actions.modulo.retenciones_masivas.files.list.downloadCfdis,
  };
};

const RetencionesMasivasFilesItemActions = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const handleOnDownloadActionClick = async (original = undefined) => {
    const { selectedRowKeys } = props;

    await actions.downloadFile(selectedRowKeys, original);
  };

  const handleOnDownloadZipActionClick = async () => {
    const { selectedRowKeys } = props;

    await actions.downloadCfdis(selectedRowKeys);
  };

  const { busy } = state;
  const { alignRight } = props;

  return (
    <Dropdown
      as={ButtonGroup}
      alignRight={alignRight}
    >
      <LoadingButton
        variant="secondary"
        loading={busy}
        onClick={() => {}}
      >
        {busy === true ? 'Procesando' : 'Acciones'}
      </LoadingButton>

      <Dropdown.Toggle
        split
        variant="secondary"
        id="dropdown-split-basic"
      />

      <Dropdown.Menu>
        {Guardian.allows('retencion.masiva.descargar.archivo.procesado') && (
          <Dropdown.Item
            as="div"
            onClick={handleOnDownloadActionClick.bind(this, undefined)}
          >
            Descargar procesado
          </Dropdown.Item>
        )}

        {Guardian.allows('retencion.masiva.descargar.archivo.original') && (
          <Dropdown.Item
            as="div"
            onClick={handleOnDownloadActionClick.bind(this, true)}
          >
            Descargar original
          </Dropdown.Item>
        )}

        {Guardian.allows('retencion.masiva.descargar.retenciones.zip') && (
          <Dropdown.Item
            as="div"
            onClick={handleOnDownloadZipActionClick.bind(this)}
          >
            Descargar zip
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
      {/* <Dropdown.Menu>
            <Dropdown.Item as="div" onClick={ this.handleOnDownloadActionClick.bind(this, 'zip') }>Cancelar procesamiento</Dropdown.Item>
          </Dropdown.Menu> */}
    </Dropdown>
  );
};

export default RetencionesMasivasFilesItemActions;
